import TelemetriaServiceUtil from "./TelemetriaServiceUtil";
import AppState from "../model/AppState";
import C5PagamentoModel from "../model/C5PagamentoModel";
import UsuarioModel from "../model/UsuarioModel";
import ReactGA from 'react-ga';
import { IExceptionTelemetry } from "@microsoft/applicationinsights-web";

export enum LogRequestTipo {
  GET = "GET",
  POST = "POST",
  PATCH = "PATCH",
  DELETE = "DELETE"
}

export default class LogUtil {
  static log(message: string) {
    // console.log(message);
  }
  static logPage(page: string) {
    if (TelemetriaServiceUtil.appInsights) {
      TelemetriaServiceUtil.appInsights.trackPageView({
        name: page,
        isLoggedIn: AppState.getUsuarioLogado() !== null,
      })
    }

    ReactGA.pageview(page);
    LogUtil.log(`CARREGOU COM SUCESSO A TELA ${page}`);
  }

  static logObject(obj: any, type: any) {
    // console.log({ obj: JSON.stringify(obj), type: typeof type });
  }

  static logException (ex: IExceptionTelemetry) {
    if (TelemetriaServiceUtil.appInsights) {
      TelemetriaServiceUtil.appInsights.trackException(ex);
    }
  }

  static logRequest(
    method: LogRequestTipo,
    name: string,
    endpoint: string,
    body: any
  ) {
    LogUtil.log(`EFETUOU UMA REQUISIÇÃO PARA ${name}:`);
    LogUtil.logObject(
      {
        name,
        method,
        endpoint,
        body
      },
      {}
    );
  }

  public static logEvento(name: string, obj: any) {
    this.logAI(name, obj);
  }

  static logCompra(compra: C5PagamentoModel) {
    this.logAI('Compra', compra);
  }

  private static logAI(evento: string, obj: any) {
    if (TelemetriaServiceUtil.appInsights) {
      TelemetriaServiceUtil.appInsights.trackEvent({ name: evento }, obj);
    }
  }

  static logHorariosAgendamento(tipo: string, agendamentos: any, usuario: UsuarioModel | null) {
    if (TelemetriaServiceUtil.appInsights) {
      TelemetriaServiceUtil.appInsights.trackEvent({
        name: "Horarios",
      }, {
        ...agendamentos,
        tipo,
        usuarioId: usuario ? usuario.clienteId : null,
      });
    }
  }

}
